import { Builder, ToOneRelation } from 'coloquent'
import { Commune } from '@/orrm/model/commune'
import { Departement } from '@/orrm/model/departement'
import { Phenomene } from '@/orrm/model/phenomene'
import { Fill, Stroke, Style } from 'ol/style'
import { centroidsResource } from '@/api'
import AbstractClusterableNode from '@/orrm/model/AbstractClusterableNode'

export class InfoReglementation extends AbstractClusterableNode {
  protected jsonApiType = 'orrm_information'
  protected static pageSize = 125
  public static readonly searchField = 'label'
  public static readonly layerId = 'infos'
  public static readonly centroidsResourceGetter = centroidsResource.getInfosCentroids

  public static readonly featureStyle = new Style({
    stroke: new Stroke({
      color: '#e1c845',
      width: 1
    }),
    fill: new Fill({
      color: 'rgba(255, 200, 69, .3)'
    })
  })

  public static readonly clusterFeatureStyle = InfoReglementation.clusterFeatureStyleFactory({
    stroke: InfoReglementation.featureStyle.getStroke(),
    fill: new Fill({
      color: 'rgba(255, 200, 69, .6)'
    })
  })

  static getQueryBuilder (): Builder<InfoReglementation> {
    return InfoReglementation
      .with('commune')
      .with('departement')
      .with('field_orrm_phenomene') as Builder<InfoReglementation>
  }

  get created (): Date {
    return this.getAttributeAsDate('changed')
  }

  get date (): Date {
    return this.getAttributeAsDate('field_orrm_date')
  }

  get label (): string {
    return this.getAttribute('label')
  }

  get referenceFile (): string {
    return this.getAttribute('reference_file')
  }

  get formattedLabel (): string {
    if (this.referenceFile) {
      return `${this.referenceFile} (${this.label})`
    }
    return this.label
  }

  commune (): ToOneRelation<Commune, this> { // eslint-disable-line
    return this.hasOne(Commune)
  }

  departement (): ToOneRelation<Departement, this> { // eslint-disable-line
    return this.hasOne(Departement)
  }

  field_orrm_phenomene (): ToOneRelation<Phenomene, this> { // eslint-disable-line
    return this.hasOne(Phenomene)
  }

  getCommune (): Commune {
    return this.getRelation('commune')
  }

  getDepartement (): Departement {
    return this.getRelation('departement')
  }

  getPhenomene (): Phenomene {
    return this.getRelation('field_orrm_phenomene')
  }
}
